import {
  AiFillFacebook,
  AiOutlineGithub,
  AiOutlineLinkedin,
  AiOutlineYoutube,
} from "react-icons/ai";

export const SOCIAL_ICONS = [
  {
    icon: <AiOutlineLinkedin size={23} />,
    href: "https://www.linkedin.com/in/noyon-islam-095342237/",
  },
  {
    icon: <AiOutlineYoutube size={23} />,
    href: "https://www.youtube.com",
  },
  // {
  //     icon: <AiOutlineTwitter size={23} />,
  //     href: "https://twitter.com/coderkhalid"
  // },
  {
    icon: <AiOutlineGithub size={23} />,
    href: "https://github.com/codeernoyon",
  },
  {
    icon: <AiFillFacebook size={23} />,
    href: "https://www.facebook.com/mdmajadulislam.nayan",
  },
];
